import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiData } from '@wix/da-bi/pkg/events';
import EditIcon from '@wix/da-ds/pkg/Icons/24x24/Edit';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarEditButton from '../../_partials/items/ActionBarEditButton';
import { useEditDeviationAction } from '../../actionHooks/useEditDeviationAction';
export const EditButton = ({ deviation })=>{
    const { t } = useTranslation();
    const onClick = useEditDeviationAction(deviation);
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        tooltip: t('actionbar.edit')
    }, /*#__PURE__*/ React.createElement(ActionBarEditButton, {
        onClick: onClick,
        biData: BiData({
            evid: 371,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId
        })
    }, /*#__PURE__*/ React.createElement(ActionBarIcon, {
        icon: EditIcon
    })));
};
EditButton.displayName = 'EditButton';
export default EditButton;
